import {EntityStateAdapter} from '@/store/base.store';
import {ChallengeModel} from '@/models/challenge.model';
import {Action, Module} from 'vuex-module-decorators';
import {UserApi} from '@/api/user.api';
import {take} from 'rxjs/operators';
import store from '@/store';
import {followedState} from '@/utils/store-acessor';
import {PaginatedParams} from '@/api/base.api';
import {UserTypes} from '@/models/user.model';

export const featureKey = 'accepted_challenges';

// @ts-ignore
if (store.state.accepted_challenges) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class AcceptedChallengesStoreModule extends EntityStateAdapter<ChallengeModel> {

  get acceptedChallenges(): ChallengeModel[] {
    return this._entities;
  }

  get loading(): boolean {
    return super.loading;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get total(): number {
    return super.total;
  }

  get entities(): ChallengeModel[] {
    return super.entities;
  }

  get userHasAccepted(): (challengeId: number) => boolean {
    return (challengeId: number) => !!this._entities.find((v) => v.id === challengeId && v.is_contestant)
  }

  @Action({commit: 'upsertMany', rawError: true})
  async fetchAcceptedChallenges(data: {
    params: PaginatedParams,
    roles?: UserTypes[]
  }): Promise<ChallengeModel[]> {
    this.context.commit('loadingUpdated', true);
    const response = await (new UserApi()).getChallenges(data.params, data.roles).pipe(take(1)).toPromise();
    this.context.commit('updateAllPageParams', response);
    this.context.commit('loadingUpdated', false);
    return response?.data || [];
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchMyChallenges(data: {
    params: PaginatedParams,
    roles?: UserTypes[]
  }): Promise<ChallengeModel[]> {
    this.updateLoading(true);
    const response = await (new UserApi()).getChallenges(data.params, data.roles).pipe(take(1)).toPromise();
    this.context.commit('updateAllPageParams', response);
    return response?.data || [];
  }

  @Action({commit: 'removeOne', rawError: true})
  async abortChallenge(challengeId: number): Promise<number> {
    await (new UserApi()).abortChallenge(challengeId).pipe(take(1)).toPromise();
    return challengeId;
  }

  @Action({rawError: true})
  async acceptChallenge(challengeId: number) {
    await (new UserApi())
      .acceptChallenge(challengeId)
      .pipe(take(1))
      .toPromise();

    const followedChallenges = followedState.followedChallenges;
    if (followedChallenges && !followedChallenges.find(({id}: any) => id === challengeId)) {
      await (new UserApi())
        .follow(challengeId)
        .pipe(take(1))
        .toPromise();
    }

  }
}
